<template>
  <img src="~/assets/icon/icon-clear-text.svg" />
</template>
